<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
<div class="flex flex-col items-center m-4 h-full overflow-auto">

  <p-card class="flex m-4 p-4 w-max">

    <ng-template pTemplate="title">
      <div class="flex flex-col items-center mt-2 space-y-2">
        <h1>Units</h1>
        <div class="flex space-x-2">
          <p-button severity="danger" outlined="true" icon="pi pi-refresh" label="Reset to API" (onClick)="resetToApi()">
          </p-button>
          <p-button severity="danger" outlined="true"  icon="pi pi-refresh" label="Reset to SI"  (onClick)="resetToSi()">
          </p-button>
          <p-button severity="danger" outlined="true"  icon="pi pi-refresh" label="Reset to Mixed Units" (onClick)="resetToMix()">
          </p-button>
        </div>

      </div>

      <hr class="my-4" />
    </ng-template>

    @if (units) {
      <div class="grid grid-cols-1 gap-4">
        <div>
          <input
            type="text"
            placeholder="Search units"
            [(ngModel)]="searchTerm"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

        <div>
          <div class="flex flex-col space-y-2">

            @if (shouldShowField('Length')) {
              <div class="flex flex-col">
                <label for="longLengths">Length</label>
                <p-select [(ngModel)]="units.longLengths" [options]="longLengthUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }

            @if (shouldShowField('Diameter')) {
              <div class="flex flex-col">
                <label for="shortLengths">Diameter</label>
                <p-select [(ngModel)]="units.shortLengths" [options]="shortLengthUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Weight per length')) {
              <div class="flex flex-col">
                <label for="linearDensity">Weight per length</label>
                <p-select [(ngModel)]="units.linearDensity" [options]="linearDensityUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Temperature')) {
              <div class="flex flex-col">
                <label for="temperature">Temperature</label>
                <p-select [(ngModel)]="units.temperature" [options]="temperatureUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Pressure')) {
              <div class="flex flex-col">
                <label for="pressure">Pressure</label>
                <p-select [(ngModel)]="units.pressure" [options]="pressureUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Stress Pressure')) {
              <div class="flex flex-col">
                <label for="stressPressure">Stress Pressure</label>
                <p-select [(ngModel)]="units.stressPressure" [options]="stressPressureUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Dogleg Severity')) {
              <div class="flex flex-col">
                <label for="doglegSeverity">Dogleg Severity</label>
                <p-select [(ngModel)]="units.doglegSeverity" [options]="dlsUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Temperature Gradient')) {
              <div class="flex flex-col">
                <label for="temperatureGradient">Temperature Gradient</label>
                <p-select [(ngModel)]="units.temperatureGradient" [options]="tempGradientOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Liquid Density')) {
              <div class="flex flex-col">
                <label for="density">Liquid Density</label>
                <p-select [(ngModel)]="units.density" [options]="densityUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Yield Point')) {
              <div class="flex flex-col">
                <label for="yieldPoint">Yield Point</label>
                <p-select [(ngModel)]="units.yieldPoint" [options]="yieldPointUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Plastic Viscosity')) {
              <div class="flex flex-col">
                <label for="plasticViscosity">Plastic Viscosity</label>
                <p-select [(ngModel)]="units.plasticViscosity" [options]="plasticViscosityUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
          </div>
        </div>

        <div>
          <div  class="flex flex-col space-y-2">
            @if (shouldShowField('Solids Density')) {
              <div class="flex flex-col">
                <label for="density">Solids Density</label>
                <p-select [(ngModel)]="units.solidsDensity" [options]="solidsDensityUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Force')) {
              <div class="flex flex-col">
                <label for="force">Force</label>
                <p-select [(ngModel)]="units.force" [options]="forceUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Thermal Conductivity')) {
              <div class="flex flex-col">
                <label>Thermal Conductivity</label>
                <p-select [(ngModel)]="units.thermalConductivity" [options]="thermalConductivityUnitOptions"
                  appendTo="body" optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Specific Heat')) {
              <div class="flex flex-col">
                <label>Specific Heat Capacity</label>
                <p-select [(ngModel)]="units.specificHeatCapacity" [options]="specificHeatCapacityUnitOptions"
                  appendTo="body" optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Thermal Expansion')) {
              <div class="flex flex-col">
                <label>Thermal Expansion Coefficient</label>
                <p-select [(ngModel)]="units.coefficientOfThermalExpansion" [options]="thermalExpansionCoeffUnitOptions"
                  appendTo="body" optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Gas Gradient')) {
              <div class="flex flex-col">
                <label>Gas Gradient</label>
                <p-select [(ngModel)]="units.gasGradient" [options]="gasGradientOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Standard Fluid Flow')) {
              <div class="flex flex-col">
                <label>Standard Fluid Flow Rate</label>
                <p-select [(ngModel)]="units.standardFluidFlow" [options]="standardFluidFlowUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Hydrocarbon Flow')) {
              <div class="flex flex-col">
                <label>Hydrocarbon Flow Rate</label>
                <p-select [(ngModel)]="units.hydrocarbonFlow" [options]="hydrocarbonFlowUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Gas Flow')) {
              <div class="flex flex-col">
                <label>Gas Flow Rate</label>
                <p-select [(ngModel)]="units.gasInjectionRate" [options]="gasInjectionRateUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }

            @if (shouldShowField('Power')) {
              <div class="flex flex-col">
                <label>Power</label>
                <p-select [(ngModel)]="units.power" [options]="powerUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }

            @if (shouldShowField("K'")) {
              <div class="flex flex-col">
                <label>K'</label>
                <p-select [(ngModel)]="units.kPrime" [options]="kPrimeUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
          </div>
        </div>

        <div>
          <div  class="flex flex-col space-y-2">
            @if (shouldShowField('Mass Flow')) {
              <div class="flex flex-col">
                <label>Mass Flow Rate</label>
                <p-select [(ngModel)]="units.massFlow" [options]="massFlowOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Slurry Flow')) {
              <div class="flex flex-col">
                <label>Slurry Flow Rate</label>
                <p-select [(ngModel)]="units.slurryFlow" [options]="slurryFlowRateOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Volume')) {
              <div class="flex flex-col">
                <label>Volume</label>
                <p-select [(ngModel)]="units.volume" [options]="volumeUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Area')) {
              <div class="flex flex-col">
                <label>Area</label>
                <p-select [(ngModel)]="units.area" [options]="areaUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Speed')) {
              <div class="flex flex-col">
                <label for="speed">Speed</label>
                <p-select [(ngModel)]="units.speed" [options]="speedUnitOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Enthalpy')) {
              <div class="flex flex-col">
                <label for="enthalpy">Enthalpy</label>
                <p-select [(ngModel)]="units.enthalpy" [options]="enthalpyOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Heat')) {
              <div class="flex flex-col">
                <label for="heat">Heat</label>
                <p-select [(ngModel)]="units.heat" [options]="heatOptions" appendTo="body" optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Torque')) {
              <div class="flex flex-col">
                <label for="torque">Torque</label>
                <p-select [(ngModel)]="units.torque" [options]="torqueOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Heat Transfer')) {
              <div class="flex flex-col">
                <label for="heatTransferCoefficient">Heat Transfer Coefficient</label>
                <p-select [(ngModel)]="units.heatTransferCoefficient" [options]="heatTransferCoefficientOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
            @if (shouldShowField('Pressure Loss')) {
              <div class="flex flex-col">
                <label for="pressureLoss">Pressure Loss</label>
                <p-select [(ngModel)]="units.pressureLoss" [options]="pressureLossOptions" appendTo="body"
                  optionValue="key"></p-select>
              </div>
            }
          </div>
        </div>

      </div>

      <div class="flex justify-end mt-4 ">
        <form (ngSubmit)="onCancel()">
          <p-button class="mr-2" severity="danger" outlined="true" type="cancel">Cancel</p-button>
        </form>

        <p-button class="mr-2" severity="success" outlined="true" (onClick)="onApply()">Apply</p-button>

        <form (ngSubmit)="onUserMetadataFormSubmit()">
          <p-button severity="success" outlined="true" type="submit">Save</p-button>
        </form>
        </div>

      </div>
    }

  </p-card>

</div>
</app-tool-loader>